var map = {
	"./app.svg": 9849,
	"./fail.svg": 741,
	"./logo.svg": 9443,
	"./more.svg": 9097,
	"./reload.svg": 9610,
	"./sina.svg": 8868,
	"./success.svg": 6744,
	"./warning.svg": 4238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;